import React, { useState } from "react";
import { toast } from "react-toastify";
import api from "../../../utils/api";

export default function ContactUs() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent! We'll get back to you soon.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch {
      toast.error("Failed to send. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-6 py-12">
      <h1 className="font-display font-bold text-3xl text-slate-900 mb-2">Contact Us</h1>
      <p className="text-slate-500 mb-8">Have questions? We'd love to hear from you.</p>

      <div className="card">
        <form onSubmit={handleSubmit} className="space-y-4">
          {[
            { field: "name", label: "Your Name", type: "text" },
            { field: "email", label: "Email Address", type: "email" },
            { field: "subject", label: "Subject", type: "text" },
          ].map(({ field, label, type }) => (
            <div key={field}>
              <label className="block text-xs font-semibold text-slate-500 mb-1.5 uppercase tracking-wide">
                {label}
              </label>
              <input
                type={type}
                value={form[field]}
                onChange={(e) => setForm((f) => ({ ...f, [field]: e.target.value }))}
                required
                className="input-field"
              />
            </div>
          ))}
          <div>
            <label className="block text-xs font-semibold text-slate-500 mb-1.5 uppercase tracking-wide">
              Message
            </label>
            <textarea
              value={form.message}
              onChange={(e) => setForm((f) => ({ ...f, message: e.target.value }))}
              rows={5}
              required
              className="input-field resize-none"
            />
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? "Sending…" : "Send Message"}
          </button>
        </form>
      </div>
    </div>
  );
}
